import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { contentList, impactProjects } from "./contentList";
import Carousel from "react-bootstrap/Carousel";

import "./singleWork.scss";
import AnimatedPages from "../../Animation/AnimatedPages";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SingleWork = () => {
  const [project, setProject] = useState(contentList[2]);
  const { child } = useParams();
  let history = useHistory();
  let query = useQuery();
  let impact = query.get("impact");
  const projectNumber = Number(child);
  console.log(contentList);

  useEffect(() => {
    if (impact) {
      if (impactProjects[projectNumber] !== undefined) {
        setProject(impactProjects[projectNumber]);
      } else {
        history.push("/our-work/0?impact=true");
      }
    } else {
      if (contentList[projectNumber] !== undefined) {
        setProject(contentList[projectNumber]);
      } else {
        history.push("/our-work/0");
      }
    }
  }, [impact, projectNumber, history]);

  return (
    <AnimatedPages>
      <div className="container single-work-parent">
        <div className="row">
          <div className="col-lg-12 ">
            <div className="container single-work">
              <h1 className="project-title">{project.projectName}</h1>
              <h2 className="partners h5">{project.subTitle}</h2>
              <div className="row align-items-start text-left">
                <div className="col-lg-4 col-12">
                  <div className="header mt-3">
                    {project?.boldDiscription ? (
                      <h5 className="fw-bold">{project.boldDiscription}</h5>
                    ) : (
                      <h2 className="partners">
                        <span className="bold">
                          {" "}
                          {!project.potentialClient
                            ? project.client
                              ? "Client:"
                              : project.partners
                              ? "Partners:"
                              : ""
                            : project.potentialClient
                            ? "Potential Client:"
                            : project.partners
                            ? "Partners:"
                            : ""}
                        </span>{" "}
                        {project.partners}
                      </h2>
                    )}

                    {project?.type && (
                      <h3 className="project-type">
                        <span className="bold">Type: </span> {project.type.text}{" "}
                        {project.type.icon.icon1 ? (
                          <span className="mx-1 icon-header">
                            <i className={project.type.icon.icon1}></i>
                          </span>
                        ) : (
                          ""
                        )}
                        {project.type.icon.icon2 ? (
                          <span className="mx-1 icon-header">
                            <i className={project.type.icon.icon2}></i>
                          </span>
                        ) : (
                          ""
                        )}
                        {project.type.icon.image ? (
                          <span className="ms-1">
                            <img
                              src={project.type.icon.image}
                              style={{ width: "20px", marginBottom: "5px" }}
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </h3>
                    )}
                  </div>
                  {project?.carousel?.images?.length > 0 ? (
                    <Carousel
                      className="col-12 d-lg-none d-block"
                      variant="dark"
                      indicators={false}
                    >
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={project.carousel?.images[0]}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={project.carousel?.images[1]}
                          alt="Second slide"
                        />
                      </Carousel.Item>
                    </Carousel>
                  ) : (
                    <div className="col-12 d-lg-none d-block">
                      <img className="w-100" src={project.singleImage} />
                    </div>
                  )}

                  {project.projectDescription ? (
                    <div className="challenge my-3">
                      <h5>Project Description</h5>
                      <p>{project.projectDescription}</p>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* // {project?.boldDiscription ? (
                  //   <h5 className="fw-bold">{project.boldDiscription}</h5>
                  // ) : (
                  //   ""
                  // )} */}
                  {project.projectDescriptionList ? (
                    <div className="challenge my-3">
                      <h5>Project Description</h5>
                      <ul className="">
                        {project.projectDescriptionList.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}

                  {project.challenge ? (
                    <div className="challenge my-3">
                      <h5>Challenge</h5>

                      <p
                        dangerouslySetInnerHTML={{
                          __html: project.challenge,
                        }}
                      />

                      {project?.challenge2 ? (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: project.challenge2,
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  {project.challengeList ? (
                    <div className="challenge my-3">
                      <h5>Challenge</h5>
                      <ul className="">
                        {project.challengeList.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.coverage ? (
                    <div className="challenge my-3">
                      <h5>Coverage</h5>
                      <p>{project.coverage}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.Squad ? (
                    <div className="challenge my-3">
                      <h5>Squad</h5>
                      <p>{project.Squad}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.originalUsage ? (
                    <div className="challenge my-3">
                      <h5>Original usage</h5>
                      <p>{project.originalUsage}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.globalText ? (
                    <div className="challenge my-3">
                      <div className="">
                        {project.globalText.map((point, index) => (
                          <p key={index}>{point}</p>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {project.howWorks ? (
                    <div className="challenge my-3">
                      <h5>How it works</h5>
                      <p>{project.howWorks}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.useCases ? (
                    <div className="challenge my-3">
                      <h5>Use cases</h5>
                      <p>{project.useCases}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.Objective ? (
                    <div className="challenge my-3">
                      <h5>Objective</h5>
                      <p>{project.Objective}</p>
                    </div>
                  ) : (
                    ""
                  )}

                  {project.Achievement ? (
                    <div className="challenge my-3">
                      <h5>Achievement</h5>
                      <p>{project.Achievement}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.approach ? (
                    <div className="challenge my-3">
                      <h5>Approach</h5>
                      <p>{project.approach.text}</p>
                      <ul className="ps-4">
                        {project.approach.points
                          ? project.approach.points.map((point, index) => (
                              <li key={index}>{point}</li>
                            ))
                          : ""}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.otherBenefits ? (
                    <div className="challenge my-3">
                      <h5>Other Benefits</h5>
                      <ul className="">
                        {project.otherBenefits.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {project.technologies.length > 0 && (
                    <div className="technologies mt-3">
                      <h5 className="mb-3">Technologies</h5>
                      <div className="icons row m-0 align-items-end">
                        {project.technologies.map((technology, index) => (
                          <div
                            key={index}
                            className={`${
                              technology.large
                                ? "col-6"
                                : technology.semiLarge
                                ? "col-4"
                                : "col-3"
                            } row m-0 p-0 text-center`}
                          >
                            <div style={{ minHeight: "65px" }}>
                              <img
                                className="img-fluid"
                                src={technology.image}
                                alt={technology.name}
                                style={{
                                  padding: technology.withPadding ? "8px" : "",
                                }}
                              />
                            </div>
                            <div className="" style={{ fontSize: "11px" }}>
                              {technology.name}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {project?.carousel?.images?.length > 0 ? (
                  <Carousel
                    className="col-lg-8 col-12 d-none d-lg-block"
                    variant="dark"
                    indicators={false}
                  >
                    <Carousel.Item>
                      <img
                        className={`d-block ${
                          project.horizontal ? "w-75 m-auto" : "w-100"
                        } `}
                        src={project.carousel.images[0]}
                        alt="First slide"
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className={`d-block ${
                          project.horizontal ? "w-75 m-auto" : "w-100"
                        } `}
                        src={project.carousel.images[1]}
                        alt="Second slide"
                      />
                    </Carousel.Item>
                    {project?.carousel?.images[2] && (
                      <Carousel.Item>
                        <img
                          className={`d-block ${
                            project.horizontal ? "w-75 m-auto" : "w-100"
                          } `}
                          src={project?.carousel?.images[2]}
                          alt="Second slide"
                        />
                      </Carousel.Item>
                    )}
                  </Carousel>
                ) : (
                  <div className="col-lg-8 col-12 d-none d-lg-flex justify-content-center">
                    <img
                      className={`${project.graveler ? "w-100" : "w-75"}`}
                      src={project.singleImage}
                    />
                  </div>
                )}

                <div className="col-12 d-lg-none d-block"></div>

                <div className="col-12 d-flex flex-wrap justify-content-between align-items-center">
                  <div className="my-4 col-md-4 col-12 p-0 ">
                    {project.urlGroup ? (
                      <>
                        <a
                          href={project.urlGroup.url.url}
                          className="visit mb-2 text-center"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-block", minWidth: "180px" }}
                        >
                          {project.urlGroup.url.btnText
                            ? project.urlGroup.url.btnText
                            : `Visit Website (${project.urlGroup.url.name})`}
                        </a>
                        <br />
                        <a
                          href={project.urlGroup.url2.url}
                          className="visit  text-center"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-block", minWidth: "180px" }}
                        >
                          {project.urlGroup.url2.btnText
                            ? project.urlGroup.url2.btnText
                            : `Visit Website (${project.urlGroup.url2.name})`}
                        </a>
                      </>
                    ) : project.url ? (
                      <a
                        href={project.url}
                        className="visit"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Visit Website
                      </a>
                    ) : (
                      ""
                    )}
                    <div className="row justify-content-between mt-4">
                      {project.comisonSoon && (
                        <div
                          className="w-100 text-center fs-5"
                          style={{ fontStyle: "italic" }}
                        >
                          Coming Soon
                        </div>
                      )}

                      {project.googlePlayUrl ? (
                        <div className="col-6 pe-1">
                          <a
                            href={project.googlePlayUrl.url}
                            rel="noreferrer"
                            target="_blank"
                            style={{
                              pointerEvents: project.comisonSoon
                                ? "none"
                                : "painted",
                              opacity: project.comisonSoon ? 0.5 : 1,
                            }}
                          >
                            <img
                              className="img-fluid h-100"
                              src={project.googlePlayUrl.img}
                              alt="googlePlayUrl"
                            />
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {project.appStoreUrl ? (
                        <div className="col-6 pe-1">
                          <a
                            href={project.appStoreUrl.url}
                            rel="noreferrer"
                            target="_blank"
                            style={{
                              pointerEvents: project.comisonSoon
                                ? "none"
                                : "painted",
                              opacity: project.comisonSoon ? 0.5 : 1,
                            }}
                          >
                            <img
                              className="img-fluid h-100"
                              src={project.appStoreUrl.img}
                              alt="appStoreUrl"
                            />
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <Link
                    to={
                      impact
                        ? `/our-work/${projectNumber + 1}?impact=true`
                        : `/our-work/${projectNumber + 1}`
                    }
                    className="nextPro col-md-4 col-12 d-flex flex-wrap justify-content-end align-items-end"
                  >
                    <h6>Next Project</h6>
                    <span className="ms-2">
                      <i className="fas fa-chevron-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedPages>
  );
};

export default SingleWork;
